// Copyright 1999-2022. Plesk International GmbH. All rights reserved.
import { db } from "../firebase";
const TrazabilidadStore = {
  namespaced: true,
  state: () => ({}),
  mutations: {},
  actions: {
    async trazabilidadEstadoUsuarios(context, payload) {
      try {
        await db.collection("trazabilidadestado").add({
          ...payload,
          fechahora: Date.now(),
        });
      } catch (error) {
        console.log(error);
      }
    },
  },
  getters: {},
};

export default TrazabilidadStore;
